import React, { ChangeEvent, useState } from 'react';
import { API } from '../services/api';

interface Props {
  onAccessGranted: (token: string) => void;
}

const Login = (props: Props) => {
  const [username, setUsername] = useState<string>();
  const [password, setPassword] = useState<string>();

  const submitLogin = async () => {
    let authToken;
    try {
      authToken = (
        await API.post(`auth/host/login`, {
          username,
          password,
        })
      ).token;
    } catch (e) {
      if (e.status === 401) {
        return;
      }
      throw e;
    }
    props.onAccessGranted(authToken);
  };

  const handleUsernameChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setPassword(e.target.value);
  };

  return (
    <>
      <div className="login-page">
        <div className="login-box">
          <div className="login-logo">ElektroLotse</div>

          <div className="card">
            <div className="card-body login-card-body">
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Benutzername"
                  onChange={handleUsernameChange}
                  onKeyDown={(e) => e.keyCode === 13 && submitLogin()}
                />
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Passwort"
                  onChange={handlePasswordChange}
                  onKeyDown={(e) => e.keyCode === 13 && submitLogin()}
                />
              </div>
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    onClick={submitLogin}
                    className="btn btn-primary btn-block"
                  >
                    Anmelden
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
